import { useCallback, useMemo } from 'react';
import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from 'api/auth';

const authHeaders = () => ({ Authorization: getAccessTokenApi() });

/**
 * Hook para GET/PUT de roles-editores de componentes por tenant.
 *
 * get(tenantId)  → { roles: string[] }
 * set(tenantId, roles) → { roles: string[] } (respuesta del PUT)
 *
 * Endpoints: GET/PUT /liftlogic/tenants/:tenantId/component-edit-roles
 * Solo accesible por USER_LIFTLOGIC.
 */
const useComponentEditRolesApi = () => {
  const get = useCallback(async (tenantId) => {
    const { data } = await axios.get(
      `${API_PATH}/liftlogic/tenants/${tenantId}/component-edit-roles`,
      { headers: authHeaders() }
    );
    return data; // { roles: [...] }
  }, []);

  const set = useCallback(async (tenantId, roles) => {
    const { data } = await axios.put(
      `${API_PATH}/liftlogic/tenants/${tenantId}/component-edit-roles`,
      { roles },
      { headers: authHeaders() }
    );
    return data; // { roles: [...] }
  }, []);

  return useMemo(() => ({ get, set }), [get, set]);
};

export default useComponentEditRolesApi;
